




























import {
  saveProjectPropertyKey,
  SaveProjectPropertyKeyCommand
} from "@/api/project/project-properties-api";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class ProjectPropertyKeyCreatePage extends Vue {
  error: string = "";
  command: SaveProjectPropertyKeyCommand = {
    name: ""
  };

  async submit() {
    try {
      await saveProjectPropertyKey(this.command);
    } catch (error) {
      this.error = error[0];

      return;
    }
    this.$router.push({ name: "project-property-keys" });
  }

  clickSubmitButton() {
    (this.$refs["btnSubmit"] as any).click();
  }
}
